/**
 * 회사코드별 메뉴 설정 예시 파일
 * 
 * 사용법:
 * 1. 이 파일을 복사하여 실제 회사코드명으로 변경하세요 (예: 1000.js, 2000.js)
 * 2. 설정을 수정하세요
 * 3. companies/index.js 파일에 import 및 추가하세요
 * 
 * 회사코드는 4자리 숫자(0000~9999)로 구성됩니다.
 */

export default {
  // 게임별 활성화 상태
  games: {
    sports: false,
    minigame: false,  // 미니게임 비활성화
    casino: true,
    slot: true,
  },
  
  // 기능별 활성화 상태 (선택사항, 기본값 사용 시 생략 가능)
  // features: {
  //   betting: true,
  //   settlement: true,
  //   userManagement: true,
  //   adminSettings: true,
  // },
  
  // 메뉴별 상세 설정
  menuItems: {
    // 베팅 내역 메뉴
    betting: {
      sports: false,
      minigame: false,  // 미니게임 베팅 내역 비활성화
      casino: true,
      slot: true,
    },
    
    // 미니게임 관련 메뉴 (선택사항, 기본값 사용 시 생략 가능)
    // minigame: {
    //   close: true,
    //   dhpowerball: {
    //     result: true,
    //     odds: true,
    //     setting: true,
    //   },
    // },
  }
};

